module.exports = __webpack_public_path__ + "img/logo_text_2.c2b56783.jpg";